import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type {
  InputMaybe,
  UpdateImpactMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateImpactDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface UpdateImpactInput {
  Id: string;
  Name: string;
  Rationale?: InputMaybe<string>;
  RatingGuidance?: InputMaybe<string>;
  LikelihoodAppetite?: InputMaybe<number>;
  CustomAttributeData?: InputMaybe<CustomAttributeData>;
  OwnerUserIds: string[];
  OwnerGroupIds: string[];
}

export const useUpdateImpact = createMutationHook({
  name: 'updateImpact',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.impact.update.mutationOptions({ onSuccess }),
  mapInput: (input: UpdateImpactInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.impact.impacts.queryKey(),
    trpc.frontend.impact.impactById.queryKey(),
    trpc.frontend.impact.impactList.queryKey(),
    // Impact updates may affect rating views
    trpc.frontend.impactRating.impactRatingsWithAppetites.queryKey(),
  ],
  mapResponse: (): UpdateImpactMutation => ({
    updateImpactApi: {
      __typename: 'GenericMutationOutput',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateImpactDocument,
  graphqlVariables: (input: UpdateImpactInput) => ({ object: input }),
  evictFields: ['impact', 'impact_rating'],
});
